import { Component, Input, signal, OnInit } from '@angular/core';
import { SvgIconsComponent } from '../../../commonComponent/svg-icons/svg-icons.component';
import { Router } from '@angular/router';
import { ToastrMessageComponent } from '../../../commonComponent/formComponent/toastr-message/toastr-message.component';
import { RouterModule } from '@angular/router';

import { VERSION } from '../../../../../version-status';
import { AuthApis } from '../../../../services/authApis';

@Component({
    selector: 'app-auth-layout',
    imports: [
    RouterModule,
    SvgIconsComponent
],
    templateUrl: './auth-layout.component.html',
    styleUrl: './auth-layout.component.css'
})
export class AuthLayoutComponent implements OnInit {
  @Input() payload: any = {};
  loading: boolean = false;

  fVersion = VERSION
  bVersion = signal<string>('')

  constructor(
    private router: Router,
    private authApis: AuthApis,
    private toastr: ToastrMessageComponent
  ) { }

  rightSIdeTexts:any = [
    {title: 'Intelligent Routing', subTitle: 'AI-powered route optimization that adapts to real-time conditions', icon: 'location'},
    {title: 'Performance Analytics', subTitle: 'Comprehensive dashboards with actionable insights', icon: 'dash-pie'},
    {title: 'Enterprise Security', subTitle: 'Bank-level encryption and compliance with industry standards', icon: 'shield'},
  ]

  ngOnInit(): void {
    this.getBackendVersion()
  }

  getBackendVersion(){
    this.authApis.getBackendVersion().subscribe({
      next: (res: any) => {
        this.bVersion.set(res?.version)
      },
      error: err => {
        this.toastr.showError(err?.message)
      }
    })
  }


}
